module.exports = __webpack_public_path__ + "img/d040cbc14a5f6752ca2a148abcad476c.png";